import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

interface PageHeaderProps {
  title: string;
  onBack?: () => void;
  backPath?: string;
  rightContent?: React.ReactNode;
  showBackButton?: boolean;
}

export function PageHeader({ 
  title, 
  onBack, 
  backPath,
  rightContent,
  showBackButton = true
}: PageHeaderProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="bg-white py-4 px-6 flex items-center justify-between border-b sticky top-0 z-10 shadow-sm">
      <div className="flex items-center gap-2">
        {showBackButton && (
          <button 
            onClick={handleBack} 
            className="mr-1 p-1"
            aria-label={t("common.back")}
          >
            <ArrowLeft size={18} />
          </button>
        )}
        <h1 className="text-base sm:text-xl font-semibold truncate max-w-[220px] sm:max-w-none">{title}</h1>
      </div>
      <div className="flex items-center">
        {rightContent || <LanguageSwitcher />} 
      </div>
    </div>
  );
}

export default PageHeader; 